export default __webpack_public_path__ + "static/ml-2-fa54ef047587337e1f6e6e0cc4a9372d.png";